import { render, staticRenderFns } from "./SystemComponent.vue?vue&type=template&id=7c12c3b1&"
import script from "./SystemComponent.vue?vue&type=script&lang=ts&"
export * from "./SystemComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports